import { render } from "./HobbiesInfo.vue?vue&type=template&id=22c22060"
import script from "./HobbiesInfo.vue?vue&type=script&lang=js"
export * from "./HobbiesInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__